import React, { Children, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { stringToDate } from '../../utils';
import { Portal } from 'react-overlays';

const CalendarContainer = ({ children }) => {
  const el = document.getElementById('calendar-portal');

  return <Portal container={el}>{children}</Portal>;
};

const RenderDatePicker = ({
  input,
  placeholder,
  classname,
  containerClassName,
  type,
  startDate,
  endDate,
  maxDate,
  minDate,
}) => {
  if (!startDate || !endDate) return null;
  // console.log(type, startDate, endDate)
  return (
    <Fragment>
      {type === 'start' ? (
        <DatePicker
          {...input}
          className={classname || 'form-input'}
          selected={
            input.value
              ? stringToDate(input.value, 'dmy')
              : stringToDate(startDate, 'dmy')
          }
          dateFormat="dd/MM/yyyy"
          onChange={(date) => {
            date && input.onChange(moment(date).format('DD/MM/YYYY'));
          }}
          selectsStart
          startDate={stringToDate(startDate, 'dmy')}
          endDate={stringToDate(endDate, 'dmy')}
          placeholder={placeholder || 'Nhập ngày'}
          minDate={minDate || null}
          popperContainer={CalendarContainer}
        />
      ) : (
        <DatePicker
          {...input}
          className={classname || 'form-input'}
          // selected={input.value ? moment(input.value).format('DD/MM/YYYY') : null}
          selected={
            input.value
              ? stringToDate(input.value, 'dmy')
              : stringToDate(endDate, 'dmy')
          }
          dateFormat="dd/MM/yyyy"
          onChange={(date) => {
            date && input.onChange(moment(date).format('DD/MM/YYYY'));
          }}
          selectsEnd
          startDate={stringToDate(startDate, 'dmy')}
          endDate={stringToDate(endDate, 'dmy')}
          minDate={stringToDate(startDate, 'dmy')}
          placeholder={placeholder || 'Nhập ngày'}
          maxDate={maxDate || null}
          popperClassName={containerClassName || ''}
          popperContainer={CalendarContainer}
        />
      )}
    </Fragment>
  );
};

export default RenderDatePicker;
